import request from '@/utils/request'
// 根据站点id查询团队字段配置
export function listBySiteIdSelectTearm (url, query) {
  return request({
    url: url + '/field/listBySiteIdSelectTearm',
    method: 'get',
    params: query
  })
}

// 查询大赛单数据列表
export function conditionByParticipantData (url, query) {
  return request({
    url: url + '/participantData/getListAll',
    method: 'get',
    params: query
  })
}

export function conditionByParticipantDataByParams (url, query) {
  return request({
    url: url + '/participantData/getListByParams',
    method: 'get',
    params: query
  })
}

// 查询省市区
export function listSysArea (url, query) {
  return request({
    url: url + '/actuator/area/list',
    method: 'get',
    params: query
  })
}

// 新增大赛单数据
export function addData (url, data) {
  return request({
    url: url + '/participantData',
    method: 'post',
    data: data
  })
}

// 修改大赛单数据
export function updateData (url, data) {
  return request({
    url: url + '/participantData',
    method: 'put',
    data: data
  })
}

export function getDicts (url, type) {
  return request({
    url: url + '/dict/data/type/' + type,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/registerForm/index.js